export default __webpack_public_path__ + "static/hero-background-f77c114819404f02ac09b0a1bfe25b44.png";